export default {
  // Đã lập
  Created: 1,
  // Chưa lập
  NotCreated: 0,
};
